import { AbstractModel } from '../models/abstract.model';
import { IsString, IsNumber, IsDefined, IsNotEmpty } from 'class-validator';
import { ClassInterface } from './class.interface';

export class ClassModel extends AbstractModel implements ClassInterface {
    @IsString()
    @IsDefined()
    @IsNotEmpty()
    public title: string = '';

    @IsString()
    public description: string = '';

    @IsNumber()
    public deprecationPeriod: number = 0;
}
